// extracted by mini-css-extract-plugin
module.exports = {"loading":"SharedStyles-module__loading--2S2dA","error":"SharedStyles-module__error--2IL7L"};